// App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MobileMenuProvider } from './context/MobileMenuManager';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AppRoutes from './Routes';

const App = () => {
  return (
    <AuthProvider>
      <MobileMenuProvider>
        <Router>
          <div className="min-h-screen flex flex-col bg-gray-50">
            <Navbar />
            <main className="flex-1">
              <AppRoutes />
            </main>
            <Footer />
          </div>
        </Router>
      </MobileMenuProvider>
    </AuthProvider>
  );
};

export default App;